// src/components/InputArea/InputArea.js
import React, { useState, useEffect, useRef } from 'react';
import './InputArea.css';
import { FaMicrophone } from 'react-icons/fa';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import { useTranslation } from 'react-i18next';

function InputArea({ addMessage }) {
  const { t, i18n } = useTranslation();
  const [inputText, setInputText] = useState('');
  const [isRecording, setIsRecording] = useState(false);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition
  } = useSpeechRecognition();

  useEffect(() => {
    if (transcript !== '') {
      setInputText(transcript);
    }
  }, [transcript]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputText.trim() === '') return; // Prevent adding empty messages
    addMessage(inputText);
    setInputText(''); // Clear input field after sending
    resetTranscript(); // Clear the transcript after sending
  };

  const startListening = () => {
    if (browserSupportsSpeechRecognition) {
      SpeechRecognition.startListening({ continuous: false });
    }
  };

  const stopListening = () => {
    if (browserSupportsSpeechRecognition) {
      SpeechRecognition.stopListening();
    }
  };

  const startRecording = async () => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      console.error('getUserMedia not supported in this browser.');
      return;
    }

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);
      audioChunksRef.current = [];

      mediaRecorderRef.current.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };

      mediaRecorderRef.current.onstop = async () => {
        const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/wav' });
        const formData = new FormData();
        formData.append('file', audioBlob, 'recording.wav');

        try {
          const response = await fetch('http://localhost:5000/api/transcribe', {
            method: 'POST',
            body: formData,
          });

          if (!response.ok) {
            throw new Error('Transcription failed');
          }

          const data = await response.json();
          if (data.transcript) {
            addMessage(data.transcript);
          } else {
            console.error('No transcript received');
          }
        } catch (error) {
          console.error('Error during transcription:', error);
        }
      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
    } catch (error) {
      console.error('Error accessing microphone:', error);
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && isRecording) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
    }
  };

  const handleMicButtonPress = () => {
    if (browserSupportsSpeechRecognition) {
      startListening();
    } else {
      startRecording();
    }
  };

  const handleMicButtonRelease = () => {
    if (browserSupportsSpeechRecognition) {
      stopListening();
    } else {
      stopRecording();
    }
  };

  return (
    <form className="input-area" onSubmit={handleSubmit}>
      <input
          id="chat-input" // Add an ID to target this input field
        type="text"
        placeholder={t('chat.inputPlaceholder')}
        value={inputText}
        onChange={(e) => setInputText(e.target.value)}
        dir={i18n.language === 'arabic' ? 'rtl' : 'ltr'}
      />
      <button type="submit" dir={i18n.language === 'arabic' ? 'rtl' : 'ltr'}>
        {t('chat.sendButton')}
      </button>



    </form>
  );
}

export default InputArea;
